import React from "react";
import useHook from "./useHook";
import Item from "./components/item";
import Col from "../../../UIcomponent/Column";
import StyledButton from "../../../UIcomponent/Button";
import { Redirect } from "react-router-dom";
import { Loader } from "../../../UIcomponent/Loader";
import Modal from "../../../UIcomponent/Modal";
import AvailabiltySchedule from "../../AvailabiltySchedule/AvailabiltySchedule";
import AvaiScheduleMobile from "../../AvaiScheduleMobile/AvaiScheduleMobile";

import "./DashboardListItem.scss";

export const DashboardListItem = (props) => {
  const { theme, data, lang, role, loading } = props;
  let width = window.innerWidth;
  const { states, methods, setters } = useHook(props);

  if (!states.didMount) {
    return false;
  }

  return (
    <>
      {states.invoiceAction.active && (
        <Redirect to={`/invoice/${states.invoiceAction.id}`} />
      )}
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        className="c__DashboardListItem"
      >
        <Item
          hook={{ states, setters, methods }}
          theme={theme}
          data={data}
          lang={lang}
          role={role}
          loading={loading}
        />
      </Col>
      <Modal
        visible={states.scheduleModal}
        onCancel={() => methods.setScheduleModal(false)}
      >
        <Col className="c__DashboardListItem__Schedule">
          {width > 768 ? (
            <AvailabiltySchedule
              duration={0.5}
              lang={lang}
              row={8}
              size={30}
              Data={states.scheduleState.Data}
              onSelect={methods.onSelect}
              onDeselect={methods.onDeselect}
              SessionCount={1}
              Slot={states.scheduleState.slot}
              onNextWeek={methods.onNextWeek}
              onPreviousWeek={methods.onPreviousWeek}
              ID={states.scheduleState.id}
              loading={states.scheduleState.loading}
              Loader={Loader}
              localSave={false}
              role={"Student"}
              breakPoints={{
                xl: 22,
                lg: 22,
                md: 22,
              }}
              {...props}
            />
          ) : (
            <AvaiScheduleMobile
              style={{
                minHeigth: "80%",
              }}
              duration={0.5}
              lang={lang}
              row={8}
              size={30}
              Data={states.scheduleState.Data}
              onSelect={methods.onSelect}
              onDeselect={methods.onDeselect}
              SessionCount={1}
              Slot={states.scheduleState.slot}
              onNextWeek={methods.onNextWeek}
              onPreviousWeek={methods.onPreviousWeek}
              ID={states.scheduleState.id}
              loading={states.scheduleState.loading}
              Loader={Loader}
              localSave={false}
              role={"Student"}
              {...props}
            />
          )}
          <StyledButton
            onClick={methods.submitSchedule}
            primary
            width="100%"
            height="45px"
            disable={states.scheduleState.disable}
            loading={states.scheduleState.isSubmitting}
          >
            ثبت زمان انتخابی
          </StyledButton>
          <StyledButton
            onClick={() => methods.setScheduleModal(false)}
            notHoverable
            default
            style={{
              border: "none",
            }}
            width="100%"
            height="45px"
          >
            فعلا بیخیال
          </StyledButton>
        </Col>
      </Modal>
    </>
  );
};
export default DashboardListItem;
